import React, { FC } from "react";
import { Image } from "../image";
import type { CentralBanksScreenTransactionsProps } from "@/types";
import { TextCols } from "../text-cols";

export const CentralBanksScreenTransactions: FC<
  CentralBanksScreenTransactionsProps
> = ({ content, cover }) => {
  return (
    <section className="centralBanksScreenTransactions">
      <div className="centralBanksScreenTransactions--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={766} />
        </div>
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="centralBanksScreenTransactions--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
      </div>
    </section>
  );
};
